import type { ExtractRoutesFromRegistry } from "./route-registry";
import { registerPublicRoute } from "./route-registry";
import type { RouteConfig, RouteType } from "./types";

// Import public route definitions
import FbCallBackPage from "@/pages/fbcallback";
import FbLoginPage from "@/pages/fblogin";
import LoginPage from "@/pages/login";
import PublicAbaRecordPage from "@/pages/order/public-aba-record-page";
import PublicOrderDetailPage from "@/pages/order/public-order-detail-page";
import { posRoutes } from "./protected/pos-routes";
import { route } from "./utils";

export const authRoutes: RouteConfig[] = [
  { path: "/login", component: LoginPage },
  { path: "/fblogin", component: FbLoginPage },
  { path: "/fbcallback", component: FbCallBackPage },
];

const miniAppRoutes: Record<string, RouteType> = {
  order: route("/mini-app/orders/:id", PublicOrderDetailPage),
  abaRecord: route("/mini-app/aba-records/:id", PublicAbaRecordPage),
  aba: route("/mini-app/aba/:id", PublicAbaRecordPage),
};

/**
 * Public routes map - single source of truth for route registration
 * Just add your route here and it will automatically be registered and typed!
 *
 * Note: Only routes using Record<string, RouteType> format will be included in types.
 * Routes using RouteConfig[] format (like authRoutes) will be registered but not typed.
 *
 * Example:
 *   myNewRoute: myNewRoutes,
 */
const publicRoutesMap = {
  auth: authRoutes,
  miniApp: miniAppRoutes,
  pos: posRoutes,
} as const satisfies Record<string, RouteConfig[] | Record<string, RouteType>>;

// Automatically register all routes from the map
Object.entries(publicRoutesMap).forEach(([name, routes]) => {
  registerPublicRoute(name, routes);
});

/**
 * Auto-generated type map for public routes
 * Automatically extracted from publicRoutesMap - no manual updates needed!
 * Only includes routes that use Record<string, RouteType> format
 */
export type PublicRoutesMap = ExtractRoutesFromRegistry<typeof publicRoutesMap>;
